import { getQueryParam } from '../shared/utils.js';
import { elements } from './elements.js';
import { expandFilterMenu } from '../../../includes/collapseFilterGroup.js';
import Choices from 'choices.js';

export const preloadFormFields = () => {
    const { publishedAfterInput, publishedBeforeInput, newsTypeSelect } = elements;

    if (publishedAfterInput) {
        publishedAfterInput.value = getQueryParam('published-after') || '';
    }
    if (publishedBeforeInput) {
        publishedBeforeInput.value = getQueryParam('published-before') || '';
    }
    const allChoices = {};
    if (newsTypeSelect) {
        newsTypeSelect.value = getQueryParam('newsType') || '';
        const choices = new Choices(newsTypeSelect, {
            searchEnabled: false
        });
        allChoices[newsTypeSelect.name] = choices;
    }
    if (publishedAfterInput?.value || publishedBeforeInput?.value || newsTypeSelect?.value) {
        expandFilterMenu(elements.expandableFilter);
    }

    return { allChoices };
};
